import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  checkboxInput: {
    alignItems: 'center',
    cursor: 'default',
  },

  fullWidth: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default useStyles;
